import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "input-display"
}
const _hoisted_2 = { class: "label-display" }
const _hoisted_3 = { class: "value-display" }
const _hoisted_4 = {
  key: 2,
  class: "input-display"
}
const _hoisted_5 = { class: "label-display" }
const _hoisted_6 = { class: "value-display" }
const _hoisted_7 = {
  key: 4,
  class: "errorMsg"
}
const _hoisted_8 = {
  key: 5,
  class: "errorMsg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_ModalCard = _resolveComponent("ModalCard")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, { onCancel: _ctx.closeModal }, {
    default: _withCtx(() => [
      _createVNode(_component_ModalCard, {
        onCancel: _ctx.closeModal,
        activeValidate: 
                !!(_ctx.firstname && _ctx.lastname && (_ctx.test(_ctx.telephoneMobile) || _ctx.test(_ctx.telephoneFixe))) &&
                !_ctx.isPhoneAlreadyUsed
            ,
        headerTitle: _ctx.$t(`contact.form.title.${_ctx.contact === undefined ? 'new' : 'edit'}`),
        onConfirm: _ctx.confirm
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('contact.form.subtitle')), 1),
            (_ctx.isConnectedUser)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('contact.form.firstname')), 1),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.firstname), 1)
                ]))
              : (_openBlock(), _createBlock(_component_TextInput, {
                  key: 1,
                  class: "input",
                  modelValue: _ctx.firstname,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstname) = $event)),
                  label: _ctx.$t('contact.form.firstname')
                }, null, 8, ["modelValue", "label"])),
            (_ctx.isConnectedUser)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('contact.form.lastname')), 1),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.lastname), 1)
                ]))
              : (_openBlock(), _createBlock(_component_TextInput, {
                  key: 3,
                  class: "input",
                  modelValue: _ctx.lastname,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastname) = $event)),
                  label: _ctx.$t('contact.form.lastname')
                }, null, 8, ["modelValue", "label"])),
            _createVNode(_component_TextInput, {
              class: "input",
              modelValue: _ctx.telephoneMobile,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.telephoneMobile) = $event)),
              label: _ctx.$t('contact.form.phone.mobile')
            }, null, 8, ["modelValue", "label"]),
            (_ctx.isMobilePhoneAlreadyUsed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('telephone.mobile.error')), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_TextInput, {
              class: "input",
              modelValue: _ctx.telephoneFixe,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.telephoneFixe) = $event)),
              label: _ctx.$t('contact.form.phone.fixe')
            }, null, 8, ["modelValue", "label"]),
            (_ctx.isFixePhoneAlreadyUsed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('telephone.fixe.error')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["onCancel", "activeValidate", "headerTitle", "onConfirm"])
    ]),
    _: 1
  }, 8, ["onCancel"]))
}